import type { HumanStatusResponse } from '../../sessionClient';

/**
 * Generated-password (LITE) accounts after email lookup. The send is
 * `requestPasswordReset` — a password-setup / reset email — not a sign-in
 * magic link. The password screen's "Email a login link" is a different step
 * (`LOGIN_LINK_STEP` in PasswordModule).
 */
export const PASSWORD_SETUP_STEP = 'password-setup';

export type HumanStatus = 'password' | typeof PASSWORD_SETUP_STEP | 'new';

/**
 * A generated (server-side) password means the account has no password the
 * customer knows, so route it to the password-setup step rather than a
 * password prompt; a real password routes to the password step. Mirrors the
 * legacy saga's `hasAutoGeneratedPassword`/`isNewHuman` routing.
 *
 * A leaf on purpose: both the entry step and the registration-conflict re-check
 * answer the same question, so neither owns the mapping.
 */
export function humanStatusToStep({
  isNewHuman,
  hasGeneratedPassword,
}: HumanStatusResponse): HumanStatus {
  if (isNewHuman) {
    return 'new';
  }
  if (hasGeneratedPassword) {
    return PASSWORD_SETUP_STEP;
  }
  return 'password';
}
